import lrEcharts from './_src/lrEcharts.vue'
lrEcharts.install = function(Vue) {
  Vue.component(lrEcharts.name, lrEcharts)
}

export default lrEcharts